

function fromCamelCaseToCapitalizedSpace( str: string ) {
    // Convert camelCase to Capitalized Spaces
  return str.replace( /([A-Z])/g, " $1" )
            .trim()
            .replace(/\b\w/g, (match: string) => match.toUpperCase()); ;
}




export {
    fromCamelCaseToCapitalizedSpace
};

